import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '@haldor/ui';
import { withRouter } from 'react-router-dom';
import { getSection } from 'actions/sections';
import { setPageTitle, setPageActions } from 'actions/header';
import { createBaseGroup, clearActiveBaseGroup } from 'actions/basegroups';
import { Spinner } from 'UI';
import { Block } from '@haldor/ui';
import SectionBaseGroups from 'containers/Section/Functionality/SectionBaseGroups';
import BaseGroupForm from 'containers/BaseGroups/Form/BaseGroupForm';
import Modal from 'containers/Modals/Modal';

var SectionBaseGroupPage = /*#__PURE__*/function (_Component) {
  _inherits(SectionBaseGroupPage, _Component);

  var _super = _createSuper(SectionBaseGroupPage);

  function SectionBaseGroupPage(props) {
    var _this;

    _classCallCheck(this, SectionBaseGroupPage);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var groupId = _this.props.match.params.groupId;

      if (_this.props.group == null) {
        if (groupId != null) {
          _this.props.getSection(groupId).then(function () {
            _this.props.setPageTitle(_this.props.group.title);

            _this.setState({
              loading: false
            });
          });
        }
      } else {
        _this.setState({
          loading: false
        });

        _this.props.setPageTitle(_this.props.group.title);
      }

      _this.props.setPageActions([{
        value: _this.props.translate('create-basegroup'),
        type: 'button',
        onClick: _this.toggleCreateModal,
        icon: 'plus'
      }]);
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.clearActiveBaseGroup();
    });

    _defineProperty(_assertThisInitialized(_this), "onCreateBaseGroup", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
        var translate;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                translate = _this.props.translate;
                _context.next = 3;
                return _this.props.createBaseGroup(values);

              case 3:
                _this.setState({
                  createModal: false
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "toggleCreateModal", function () {
      _this.setState({
        createModal: !_this.state.createModal
      });
    });

    _this.state = {
      loading: true,
      createModal: false
    };
    return _this;
  }

  _createClass(SectionBaseGroupPage, [{
    key: "render",
    value: function render() {
      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      var _this$props = this.props,
          group = _this$props.group,
          translate = _this$props.translate;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.createModal,
        title: translate('create-basegroup'),
        type: "small",
        onClose: this.toggleCreateModal
      }, /*#__PURE__*/React.createElement("div", {
        className: "form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(BaseGroupForm, {
        onSubmit: this.onCreateBaseGroup,
        section: group
      })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SectionBaseGroups, null)));
    }
  }]);

  return SectionBaseGroupPage;
}(Component);

function mapStateToProps(state) {
  return {
    group: state.sections.activeSection,
    translate: translate(state.Languages.translations)
  };
}

export default withRouter(connect(mapStateToProps, {
  getSection: getSection,
  setPageTitle: setPageTitle,
  setPageActions: setPageActions,
  createBaseGroup: createBaseGroup,
  clearActiveBaseGroup: clearActiveBaseGroup
})(SectionBaseGroupPage));